<template>
  <div class="container container-table" id="resetPassword">
    <div class="row">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid box-info">
            <div>
              <div class="box-body">
                <div class="row">
                  <div style="width:224px;margin:auto;">
                    <img src="../assets/img/account/developer.png" class="center-block1">
                  </div>
                  <div style="test_all">
                    <div class="text-center col-md-4 col-sm-offset-4 container">
                      <form class="ui form loginForm container">
                        <div class="div_forget">
                          <img
                            class="div_forget_image"
                            src="../../src/assets/img/account/Account_forget_password.png"
                          >
                          <span class="div_forget_span">{{ $t('account.common.ResetPassword.content.reset') }}</span>
                        </div>

                        <p class="enter_email_p" >{{ $t('account.common.ResetPassword.content.input') }}</p>

                        <div class="input-group">
                          <input
                            @input="inputFocusChange"
                            @focus="inputfocus"
                            :style="newPassword ? spacing : '' "
                            :class=" newPasswordInfo ? 'errorBorderColor' : '' "
                            class="form-control input_form"
                            ref="loginEmail"
                            name="email"
                            type="password"
                            v-model="newPassword"
                            :onKeypress="onkeyPress"
                          >
                          <p
                            class="error_p_class"
                            :class=" newPasswordInfo  ? 'errorBorderColor' : '' "
                          >{{ newPasswordInfo }}</p>
                        </div>

                        <div class="input-group">
                          <input
                            @input="inputFocusChange"
                            :style="confirmPassword ? spacing : '' "
                            @focus="inputfocus"
                            :class=" (confirmPasswordInfo || confirmPlace) ? 'errorBorderColor' : '' "
                            class="form-control input_form"
                            name="password"
                            :placeholder="confirmPlace"
                            type="password"
                            v-model="confirmPassword"
                            :onKeypress="onkeyPress"
                          >
                          <p
                            class="error_p_class"
                            :class=" confirmPasswordInfo ? 'errorBorderColor' : '' "
                          >{{ confirmPasswordInfo }}</p>
                        </div>

                        <div class="input_error_response" v-show="error_response_flag">
                          <p class="error_p_class">{{response}}</p>
                        </div>
                        <div class="input-group div_btn_login_border">
                          <button
                            :disabled="disabled"
                            :class=" { red:changeRed == true } "
                            class="btn_login"
                            @click.stop.prevent="checkCreds"
                          ><span :style=" !disabled ? 'opacity: 1;' : 'opacity: .5;' ">{{ $t('account.common.ResetPassword.content.reset') }}</span></button>
                          <span class="btn_login_border" v-show="changeRed"></span>
                        </div>
                      </form>
                    </div>
                    <!-- <LoginFooter/> -->
                  </div>
                </div>

                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from '../api'
// import config from '../config'
// import LoginFooter from './views/LoginFooter.vue'
export default {
    name: 'Login',
    // components: {
    //     LoginFooter
    // },
    data (router) {
        return {
            pwdReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
            newPassword: '',
            confirmPassword: '',
            newPasswordInfo: '',
            confirmPasswordInfo: '',
            response: null,
            spacing: 'letter-spacing: .8em',
            input_border: 'input_border',
            checkbox_flag: false,
            changeRed: false,
            focus_flag: false,
            disabled: true,
            error_response_flag: false,
            onkeyPress:
                'javascript:if(event.keyCode == 32)event.returnValue = false;',
            windowHref: null,
            confirmPlace: ''
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
        this.windowHref = window.location.href
        this.$store.state.isFrontHeaderShow = true
        this.$store.state.isFooterShow = false
    },
    methods: {
        inputFocusChange () {
            if (!this.response) {
                return
            }
            this.response = null
        },
        reds () {
            this.changeRed = true
        },
        checkCreds () {
            this.focus_flag = false
            this.changeRed = true
            this.registerToken()
        },
        registerToken () {
            this.resetResponse()
            const path =
                '/developer/reset/password'
            let windowUrl = this.windowHref
            if (windowUrl.indexOf('=') === -1) {
                return
            }
            let code = windowUrl.substring(
                windowUrl.indexOf('=') + 1,
                windowUrl.length
            )
            this._api.request('post', path, { code, password: this.confirmPassword })
                .then(response => {
                    let data = response.data.data
                    if (data.error) {
                        var errorName = data.error.name
                        if (errorName) {
                            this.response =
                                errorName === 'InvalidCredentialsError'
                                    ? this.$t('loginError')
                                    : errorName
                        } else {
                            this.response = data.error
                        }
                        return
                    }
                    this.$router.push({ name: 'userLogin' })
                })
                .catch(error => {
                    console.log(error)
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.status >= 400
                    ) {
                        this.response = this.$t('common.response.error.message.invalid')
                    } else {
                        this.response = this.$t('serverAppears')
                    }
                })
        },
        resetResponse () {
            this.response = ''
        },
        inputfocus () {
            this.resetResponse()
            this.focus_flag = true
        },
        errorFunc (type) {
            this.changeRed = false
            this.disabled = true
            if (type === '1') {
                this.confirmPasswordInfo = ''
                this.oldPasswordInfo = ''
                this.confirmPlace = ''
            } else {
                this.newPasswordInfo = ''
                this.oldPasswordInfo = ''
            }
        }
    },
    // 使用生命周期函数 实现input框样式
    beforeUpdate () {
        if (this.response) {
            this.changeRed = false
            this.disabled = true
            this.error_response_flag = true
        } else if (this.newPassword === '' || this.confirmPassword === '') {
            if (!this.newPassword) {
                this.newPasswordInfo = this.$t('account.common.ResetPassword.content.input')
                this.errorFunc('1')
                return
            }

            if (this.newPassword && !this.pwdReg.test(this.newPassword)) {
                this.newPasswordInfo = this.$t('account.common.ResetPassword.content.correct')
                this.errorFunc('1')
                return
            }
            if (!this.confirmPassword) {
                this.confirmPlace = this.$t('account.common.ResetPassword.content.inputAgain')
                this.confirmPasswordInfo = ''
                this.errorFunc()
            }
        } else {
            if (!this.pwdReg.test(this.newPassword)) {
                this.errorFunc('1')
                this.newPasswordInfo = this.$t('account.common.ResetPassword.content.correct')
            } else if (this.confirmPassword !== this.newPassword) {
                this.errorFunc()
                this.confirmPasswordInfo = this.$t('account.common.ResetPassword.content.confirm')
            } else {
                this.confirmPlace = ''
                this.newPasswordInfo = ''
                this.confirmPasswordInfo = ''
                this.changeRed = true
                this.disabled = false
                this.error_response_flag = false
            }
        }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
    }
}
</script>

<style scoped>
.error_p_class {
    width: 324px;
    height: 18px;
    opacity: 0.5;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #f64635;
    margin: 0px;
    visibility: hidden;
}
#resetPassword {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
}
#resetPassword .input-group input {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    color: #f64635 !important;
}
.errorBorderColor {
    border-color: #f64635 !important;
    color: #f64635 !important;
    line-height: 18px;
    visibility: visible;
}
.enter_email_p {
    width: 333px;
    height: 20px;
    font-size: 12px;
    color: #333333;
    text-align: left;
    margin: auto;
    margin-bottom: 18px;
}
.div_forget_span {
    width: 194px;
    height: 33px;
    font-size: 16px;
    letter-spacing: 1.2px;
    color: #333333;
}
.div_forget_image {
    width: 21px;
    height: 30px;
    vertical-align: text-bottom;
    margin-right: 6px;
}
.div_forget {
    text-align: left;
    width: 333px;
    margin: auto;
    margin-bottom: 18px;
}
.btn_login_border {
    width: 201.5px;
    height: 2px;
    background: rgba(51, 51, 51, 0.3);
    position: absolute;
    left: 10px;
    bottom: -0.8px;
}
.div_btn_login_border {
    position: relative;
    padding-bottom: 0px !important;
}
.container {
    -webkit-user-select: none;
    user-select: none;
}
.Remember_me_image {
    width: 100%;
    height: 100%;
}
.div_creat_account {
    width: 30.7em;
    height: 5.57em;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.3);
    border: solid 2.5px rgba(0, 181, 226, 0.5);
    margin: auto;
    margin-top: 13.5em;
    margin-bottom: -20.6em;
    cursor: pointer;
}
.span_creat_account {
    width: 21.4em;
    height: 2.35em;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 1.2px;
    text-align: center;
    color: #00b5e2;
    line-height: 3em;
}
.error_response_p {
    margin: 0;
}
.input_error_response {
    font-size: 14px;
    color: rgba(246, 70, 53, 0.5);
    margin: auto;
    margin-top: -0.6em;
    padding-bottom: 0.9em;
    width: 333px;
    text-align: left;
}
.label_class {
    width: 1.7em;
    height: 1.8em;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 2px;
    margin-top: -0.3em;
    cursor: pointer;
}
.red {
    background-color: #00b5e2 !important;
    opacity: 1 !important;
}
.btn_signin {
    width: 10em;
    height: 2.4em;
    outline: none;
    border: 2px solid #00b5e2;
    background: white;
    color: #00b5e2;
    font-size: 22px;
    cursor: pointer;
    border-radius: 10px;
    letter-spacing: 1.2px;
    font-weight: bold;
}
.btn_signin:hover {
    background-color: rgba(255, 255, 255, 0.5);
}
.btn_login {
    width: 10em;
    height: 2.4em;
    outline: none;
    border: 0;
    border-radius: 10px;
    font-size: 22px;
    letter-spacing: 1.2px;
    font-weight: bold;
    cursor: pointer !important;
    background-color: rgba(51, 51, 51, 0.2);
    color: #ffffff;
    margin-top: 20px;
}
.loading {
    font-size: 18px;
}
.btnStyle {
    background: #00b5e2;
    color: #ffffff;
}
.input_border {
    border-color: #f64635 !important;
    color: #f64635 !important;
}
html,
body,
.container-table {
    height: 100%;
    background-color: white !important;
}
.container-table {
    display: table;
    color: white;
    width: 72%;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
    padding-top: 20%;
}
.vertical-10p {
    padding-top: 10%;
}
.logo {
    width: 15em;
    padding: 3em;
}
.loginForm .input-group {
    height: 0;
    margin-bottom: 18px;
}
.input-group input {
    height: 2.7em;
}
#userLoginSubmitButton {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    height: 100%;
    outline: none;
}
/* [fu] */

/* 取消边框 */
.box.box-solid.box-info {
    border: none;
}
.vertical-10p {
    padding-top: 0 !important;
}
.center-block1 {
    padding-bottom: 3.5em !important;
    margin-top: 50px;
}
.box-body {
    padding-top: 0;
}
/* input */
.input-group input {
    width: 23.8em !important;
    border-radius: 4px !important;
    border: 1px solid rgba(51, 51, 51, 0.5);
    color: #333333;
}
.input-group {
    margin: auto;
    font-weight: bold;
}
/* form剧中 */
.col-sm-offset-4 {
    margin: auto;
    width: 100%;
}
.checkbox_div {
    display: flex;
    margin-left: 2em;
    margin-bottom: 3.5em;
    width: 23.8em;
    margin: auto;
    padding-bottom: 2.8em;
    margin-top: 0.3em;
    position: relative;
}
/* 这是button */
.btn-info {
    background-color: rgba(51, 51, 51, 0.2);
    border: none;
    width: 10em !important;
    margin-left: 33%;
    border-radius: 8px !important;
    font-size: 22px !important;
    height: 50px !important;
    margin-bottom: 1.5em !important;
    margin: auto;
}
.div_signin {
    width: 37em;
    padding-top: 3.2em;
    margin: auto;
}

/* input的字体大小 */
.form-control {
    padding: 6px 24px;
    font-size: 18px;
}
.Forget_password {
    height: 20px;
    font-size: 14px;
    color: #333333;
}
.Remember_me {
    font-size: 14px;
    line-height: 19px;
    color: #333333;
    padding-left: 10px;
}
.Remember_me {
    cursor: pointer;
}
.checkbox_class {
    cursor: pointer;
}
.Forget_password {
    cursor: pointer;
}
/* 加form的上下border */
.ui {
    width: 37em;
    border-top: solid 1px rgba(51, 51, 51, 0.1);
    padding-top: 3.4em;
    padding-bottom: 250px;
}
.box {
    box-shadow: none;
    margin-bottom: 0;
}
.box-body {
    padding-bottom: 0;
}
.Join-NUWA-developer {
    width: 164px;
    height: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.5);
    margin: auto;
    padding-top: 1.9em;
}

/* 底部 */
.Copyright-2018-Nuw {
    width: 400px;
    height: 20px;
    font-size: 14px;
    margin-left: 1em;
    color: #333333;
}
.copyright_a {
    color: #333333;
}
.copyright_a:hover {
    color: #333333;
}
.Login-Page_Link {
    height: 20px;
    font-size: 14px;
    color: #333333;
}
.Login-Page_Link a {
    padding: 0 18px;
    color: #333333;
}
.Login-Page_Link a:not(:last-child) {
    border-right: 1px solid;
}
.input_form {
    width: 380px;
    font-size: 14px;
    letter-spacing: 1.2px;
    color: rgba(51, 51, 51, 0.3);
}
.div_footer {
    display: flex;
    clear: both;
    margin: auto;
    padding-top: 25.8em;
    width: 57em;
}
#app {
    background: rgba(0, 181, 226, 0.1);
}

/* [新增] */
.container {
    margin: auto;
}
.label_class {
    width: 21.8px;
    height: 23.2px;
}
.input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}
.btn_signin {
    display: block;
    margin: auto;
}
.Join-NUWA-developer {
    text-align: center;
}
.input-group input {
    outline: none;
    height: 2em !important;
    width: 24.6em !important;
}
.checkbox_div {
    width: 20.2em !important;
}
/* 新增 */
</style>
